import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from "../lib/cn.js";
import { CONTROL_SURFACE } from "./input.js";
export const DateField = forwardRef(({ className, type = 'date', invalid = false, ...props }, ref) => (_jsx("input", { ref: ref, type: type, "aria-invalid": invalid || undefined, className: cn(...CONTROL_SURFACE, 'h-(--control-height-md)', className), ...props })));
DateField.displayName = 'DateField';
//# sourceMappingURL=date-field.js.map